export var ACTIONS = {
  SET_CONVERSATIONS_SEARCH: 'SET_CONVERSATIONS_SEARCH',
  SET_CONVERSATIONS_SEARCH_RESULTS: 'SET_CONVERSATIONS_SEARCH_RESULTS',
  SET_CONVERSATIONS: 'SET_CONVERSATIONS',
  SET_CONVERSATIONS_FILTER: 'SET_CONVERSATIONS_FILTER',
  SET_CONVERSATIONS_FETCHING_STATUS: 'SET_CONVERSATIONS_FETCHING_STATUS',
  SET_CONVERSATION: 'SET_CONVERSATION',
  SET_CONVERSATION_MESSAGES: 'SET_CONVERSATION_MESSAGES',
  ADD_CONVERSATION_MESSAGES: 'ADD_CONVERSATION_MESSAGES',
  ADD_NOTIFICATION_MESSAGES: 'ADD_NOTIFICATION_MESSAGES',
  UPDATE_LAST_MESSAGE: 'UPDATE_LAST_MESSAGE',
  UPDATE_CURRENT_LAST_MESSAGE: 'UPDATE_CURRENT_LAST_MESSAGE',
  UPDATE_CURRENT_TITLE: 'UPDATE_CURRENT_TITLE',
  ADD_NEW_MESSAGE: 'ADD_NEW_MESSAGE',
  REPLACE_MESSAGE: 'REPLACE_MESSAGE',
  ADD_ADMINS: 'ADD_ADMINS',
  REMOVE_ADMINS: 'REMOVE_ADMINS',
  ADD_MEMBER: 'ADD_MEMBER',
  REMOVE_MEMBERS: 'REMOVE_MEMBERS',
  REMOVE_CONVERSATION: 'REMOVE_CONVERSATION',
  RESET_NEW_MESSAGES_COUNT: 'RESET_NEW_MESSAGES_COUNT',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  SET_SELECTED_CONVERSATION: 'SET_SELECTED_CONVERSATION',
  SET_CURRENT_VIEW: 'SET_CURRENT_VIEW',
  SET_COLLAPSED: 'SET_COLLAPSED',
  SET_NEW_CONVERSATION_MEMBERS: 'SET_NEW_CONVERSATION_MEMBERS',
  SET_ONLINE_MEMBERS: 'SET_ONLINE_MEMBERS',
  ADD_ONLINE_MEMBER: 'ADD_ONLINE_MEMBER',
  REMOVE_ONLINE_MEMBER: 'REMOVE_ONLINE_MEMBER',
  SET_PIP: 'SET_PIP',
  SET_ANNOUNCE_CALL: 'SET_ANNOUNCE_CALL',
  SET_REJECT_CALL: 'SET_REJECT_CALL',
  SET_X_GROUP: 'SET_X_GROUP'
};